<template>
  <div class="card">
    <div class="card-body p-0">
      <cardHead :title="'Usage Report'"></cardHead>
      <Form
        method="dialog"
        @submit="onSubmit"
        v-slot="{ errors }"
        class="floating-labels p-1rem border-bottom m-b-0"
        ref="form"
      >
        <div class="row">
          <div class="col">
            <formGroup
              :title="'Başlangıç Tarihi'"
              type="date"
              v-model="model.StartDate"
              :max="model.EndDate"
              :rules="{ required: true }"
              :errors="errors"
              @keydown.enter="get"
            ></formGroup>
          </div>
          <div class="col">
            <formGroup
              :title="'Bitiş Tarihi'"
              type="date"
              v-model="model.EndDate"
              :min="model.StartDate"
              :rules="{ required: true }"
              :errors="errors"
              @keydown.enter="get"
            ></formGroup>
          </div>
          <div class="col-auto">
            <Btn class="btn-success btn-md" @click="get" :process="data == null"
              >Raporla</Btn
            >
          </div>
        </div>
      </Form>
      <load-area v-if="data == null"></load-area>
      <div class="row" v-if="data != null">
        <div class="col-xl-9 col-lg-8 col-md-7 col-12 left">
          <apex-chart
            :key="data.Summary.length"
            :data="getDatasets()"
            :height="237"
            :chartOptions="chartOptions"
          ></apex-chart>
        </div>
        <div class="col-xl-3 col-lg-4 col-md-5 col-12 border-left right">
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-body p-10">
                  <div class="d-flex flex-row">
                    <div class="round round-md align-self-center round-info">
                      <i class="ti-plus"></i>
                    </div>
                    <div class="m-l-10 align-self-center">
                      <h3 class="m-b-0 font-lgiht">
                        <Vue3Autocounter
                          ref="counter"
                          :startAmount="0"
                          :endAmount="getSum('Added')"
                          :duration="1"
                        />
                      </h3>
                      <h6 class="text-muted m-b-0">
                        Added
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="card">
                <div class="card-body p-10">
                  <div class="d-flex flex-row">
                    <div class="round round-md align-self-center round-success">
                      <i class="ti-settings"></i>
                    </div>
                    <div class="m-l-10 align-self-center">
                      <h3 class="m-b-0 font-lgiht">
                        <Vue3Autocounter
                          ref="counter"
                          :startAmount="0"
                          :endAmount="getSum('Operated')"
                          :duration="1"
                        />
                        <small style="font-size:70%"
                          >(%<Vue3Autocounter
                            ref="counter"
                            :startAmount="0"
                            :endAmount="
                              getSum('Percentage') / data.Summary.length
                            "
                            :duration="1"
                          />)</small
                        >
                      </h3>
                      <h6 class="text-muted m-b-0">
                        Operated
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <a
                href="#/report/using"
                class="btn waves-effect text-left btn-success btn-md btn-success btn-md w100 tcenter"
                ><span>Detaylı İncele</span></a
              >
            </div>
          </div>
        </div>
      </div>
      <dataTable
        :name="'dailyReports'"
        ref="agGrid"
        :columnDefs="columnDefs"
        v-if="data != null"
        :data="data.Customers.sort((x, y) => y.Id - x.Id)"
        @cellClicked="detailShow = { ...$event.data }"
      ></dataTable>

      <modal
        v-if="detailShow != null"
        :title="detailShow.Name + ' Detail'"
        :size="'xl'"
        @close="detailShow = null"
      >
        <template #content>
          <div class="row" v-if="data != null">
            <div class="col-xl-9 col-lg-8 col-12 left">
              <apexChart
                :data="getDatasets(detailShow.Days)"
                :height="237"
                :chartOptions="chartOptions"
              ></apexChart>
            </div>
            <div class="col-xl-3 col-lg-4 col-12 border-left right">
              <div class="row">
                <div class="col-12">
                  <div class="card">
                    <div class="card-body p-10">
                      <div class="d-flex flex-row">
                        <div
                          class="round round-md align-self-center round-info"
                        >
                          <i class="ti-plus"></i>
                        </div>
                        <div class="m-l-10 align-self-center">
                          <h3 class="m-b-0 font-lgiht">
                            <Vue3Autocounter
                              ref="counter"
                              :startAmount="0"
                              :endAmount="getSum('Added', detailShow.Days)"
                              :duration="1"
                            />
                          </h3>
                          <h6 class="text-muted m-b-0">
                            Added
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="card">
                    <div class="card-body p-10">
                      <div class="d-flex flex-row">
                        <div
                          class="round round-md align-self-center round-success"
                        >
                          <i class="ti-settings"></i>
                        </div>
                        <div class="m-l-10 align-self-center">
                          <h3 class="m-b-0 font-lgiht">
                            <Vue3Autocounter
                              ref="counter"
                              :startAmount="0"
                              :endAmount="getSum('Operated', detailShow.Days)"
                              :duration="1"
                            />
                            <small style="font-size:70%"
                              >(%<Vue3Autocounter
                                ref="counter"
                                :startAmount="0"
                                :decimals="2"
                                :endAmount="
                                  getSum('Operated', detailShow.Days) /
                                    (getSum('Added', detailShow.Days) / 100)
                                "
                                :duration="1"
                              />)</small
                            >
                          </h3>
                          <h6 class="text-muted m-b-0">
                            Operated
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
import Vue3Autocounter from "vue3-autocounter";
import apexChart from "./../../components/apexChart.vue";
export default {
  name: "onlineReservationCustomer",
  components: { Vue3Autocounter, apexChart },
  data() {
    return {
      tab: "usingReport",
      model: {
        StartDate: null,
        EndDate: null,
      },
      data: null,
      chartOptions: {
        chart: {
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 5,
            borderRadiusApplication: "last",
          },
        },
        xaxis: {
          categories: [],
        },
        tooltip: {
          y: {
            formatter: function(val, pro) {
              console.log("x", val, pro);
              if (val == 0) {
                return "";
              }
              return val;
            },
          },
        },
        dataLabels: {
          formatter: function(val) {
            // const goals =
            //   opt.w.config.series[opt.seriesIndex].data[opt.dataPointIndex]
            //     .goals;

            // if (goals && goals.length) {
            //   return "%" + goals[1].value;
            // }
            return (val / 1000).toFixed(1);
          },
        },
      },
      columnDefs: [
        {
          headerName: "Id",
          field: "Id",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agNumberColumnFilter",
          width: 40,
        },
        {
          headerName: "Name",
          field: "Name",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "Added",
          field: "Added",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          width: 140,
        },
        {
          headerName: "Operated",
          field: "Operated",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          minWidth: 140,
        },
        {
          headerName: "Percentage",
          field: "Percentage",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          minWidth: 140,
          valueFormatter: (params) => {
            return params.value.toFixed(2);
          },
        },
      ],
      detailShow: null,
    };
  },
  created() {
    var startDate = new Date();
    startDate.setDate(startDate.getDate() - 6);
    this.model = {
      StartDate: this.$moment(new Date(startDate)).format("YYYY-MM-DD"),
      EndDate: this.$moment(new Date()).format("YYYY-MM-DD"),
    };
    this.get();
  },
  methods: {
    get() {
      this.data = null;
      this.$appAxiosAdmin
        .post(`KOLAYREZ/Reports/UsingReport`, this.model)
        .then((response) => {
          this.data = response.data;
        });
    },
    getDatasets(datas = this.data.Summary) {
      var operated = [];
      var agencyConfirmed = [];
      var agencyNotConfirmed = [];
      var added = [];
      let xAxis = [];
      datas.forEach((element) => {
        xAxis.push(this.$moment(new Date(element.Date)).format("DD.MM.YY"));
        operated.push(element.Operated);
        agencyConfirmed.push(element.AgencyConfirmed);
        agencyNotConfirmed.push(element.AgencyNotConfirmed);
        added.push(element.Added);
      });
      this.chartOptions.xaxis.categories = xAxis;
      return [
        {
          name: "Added",
          type: "column",
          data: added,
        },
        {
          name: "Operated",
          type: "column",
          fillColor: "#FF0000",
          data: operated,
        },
        {
          name: "Agency Confirmed",
          type: "column",
          fillColor: "#ffb22b",
          data: agencyConfirmed,
        },
        {
          name: "Agency Not Confirmed",
          type: "column",
          fillColor: "#fc4b6c",
          data: agencyNotConfirmed,
        },
      ];
    },
    getSum(type, data = this.data.Summary) {
      let sum = 0;
      console.log(data, type);
      data
        .filter((x) => {
          return x.Added > 0;
        })
        .forEach((element) => {
          sum += element[type];
        });
      return sum;
    },
  },
};
</script>
<style scoped>
.card-body {
  overflow: hidden;
}
form .row {
  margin: -5px;
}
form .row > div {
  padding: 5px;
}
form .row > div button {
  padding: 8px 24px;
  width: 100%;
  text-align: center !important;
}
form {
  padding: 10px 20px 0px;
}
.right {
  padding: 16px 31px 16px 16px;
}
.right > .row {
  margin: -8px;
}
.right > .row > div {
  padding: 8px;
}
.right > .row > div .card {
  margin-bottom: 0;
}
.left,
/deep/ .left {
  padding-right: 0 !important;
}
/deep/ .left .vue-apexcharts > div {
  height: 0 !important;
  overflow: hidden;
}
/deep/ .left .vue-apexcharts > div:last-child {
  height: unset !important;
  overflow: visible;
}
.round-success {
  background: #55ce63;
}
.bg-success {
  background: #55ce63 !important;
}
/deep/ .modal-body {
  overflow: hidden;
}
@media (max-width: 991px) {
  .left {
    padding-right: 15px;
    border-right: none !important;
  }
  .right > .row {
    margin: -4px;
  }
  .right > .row > div {
    padding: 4px;
  }
  .right > .row > div .round {
    width: 36px;
    height: 36px;
  }
  .right > .row > div .round i {
    display: block;
    line-height: 36px;
  }
  .right > .row > div h4 {
    font-size: 16px;
  }
  .right > .row > div h6 {
    font-size: 12px;
  }
}
@media (max-width: 767px) {
  .left,
  /deep/ .left {
    padding-right: 15px !important;
  }
  .right,
  /deep/ .right {
    padding: 16px 31px;
    border-top: 1px solid #dee2e6 !important;
  }
}
</style>
